import { default_currency } from "@/helpers/data";

export const DEFAULT_STATE = {
    data: [],
    dataForFeePage: null,
    dataForPayoutsManagementPage: null,
    publisher: null,
    vatNumber: null,
    isLoading: false,
    companyAccountErrors: null,
    createPublisherErrors: null,
    deletePublisherErrors: null,
    selectedPublisherCurrency: default_currency,

    // Selected publishers and websites per mode. Period lives separately in
    // WebsiteDates store / *_website_dates LS namespace.
    selectedPublishersLtba: [],
    selectedWebsitesLtba: [],
    selectedPublishersYield: [],
    selectedWebsitesYield: [],

    // Mode management
    selectedMode: "ltba",
};
